import { API_ORIGIN, apiUrl } from "./apiOrigin";
import React, { useEffect, useState, useRef } from 'react';
import InspectorSOPStaffGrid from './InspectorSOPStaffGrid';
import ComplianceNextDue from './ComplianceNextDue';
import { TrainingResults } from './ComplianceTraining';
export const NI_PROCEDURE_SOPS = new Set(['ni-p13-3', 'ni-p13-4', 'ni-p13-5', 'ni-p13-6', 'ni-p13-7', 'ni-p13-8', 'ni-p13-10']);
export default function LinkedSopDetails({
  row,
  dbName,
  token,
  readOnly = false
}) {
  const requestSequence = useRef(0);
  const [data, setData] = useState(null),
    [error, setError] = useState('');
  const rowId = row.rowId || `el:${row.elementId}`;
  const load = async () => {
    const request = ++requestSequence.current;
    setError('');
    try {
      if (!dbName) throw Error('Branch database could not be resolved.');
      const r = await fetch(apiUrl("/api/headoffice/compliance-grid/linked-sop/details"), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token || localStorage.getItem('token') || ''}`
        },
        body: JSON.stringify({
          rowId,
          dbName
        })
      });
      const d = await r.json();
      if (!r.ok) throw Error(d.error || 'Unable to load current SOP evidence.');
      if (request === requestSequence.current) setData(d);
    } catch (e) {
      if (request === requestSequence.current) setError(e.message);
    }
  };
  useEffect(() => {
    setData(null);
    load();
    return () => {
      requestSequence.current++;
    };
  }, [rowId, dbName, token]);
  const c = data?.cell,
    documents = data?.documents || [],
    titles = data?.row?.sopTitles || [];
  return <section aria-label="Current linked SOP details" style={{
    padding: 12,
    color: '#172554',
    background: '#fff',
    fontSize: 13
  }}><h3>{row.label}</h3>{error ? <p role="alert">{error}</p> : !data ? <p>Loading current evidence…</p> : !c ? <p>This branch has no saved evidence source for this item.</p> : <>
  <p><b>Current source:</b> {c.source === 'sop' ? 'Selected Pharmace SOPs' : c.source === 'link' ? 'External link' : c.source === 'task' ? 'Staff task and document upload' : c.source || 'Not set'} · <b>{c.status}</b></p>
  {c.source === 'sop' ? <><h4>Linked SOPs</h4>{!titles.length ? <p>No SOP titles have been selected in this item’s settings.</p> : <><table style={{
            width: '100%',
            borderCollapse: 'collapse'
          }}><thead><tr><th style={{
                  textAlign: 'left'
                }}>SOP / contents</th><th>Version</th><th>Next review</th></tr></thead><tbody>{documents.map((s, i) => <tr key={s.title + i}><td style={{
                  padding: 6
                }}>{s.fileUrl ? <a href={s.fileUrl} target="_blank" rel="noreferrer">{s.title}</a> : <>{s.title} — {s.held ? 'document file missing' : 'not held at this branch'}</>}</td><td style={{
                  textAlign: 'center'
                }}>{s.version || '—'}</td><td style={{
                  textAlign: 'center'
                }}>{s.expiryDate ? new Date(s.expiryDate).toLocaleDateString('en-GB') : 'Not recorded'}</td></tr>)}</tbody></table><h4>Staff read / unread</h4><InspectorSOPStaffGrid pharmacyId={dbName} asOfDate={new Date().toISOString().slice(0, 10)} token={token} sopTitlesFilter={titles} /></>}</> : <>
   {c.linkUrl && <p><a href={c.linkUrl} target="_blank" rel="noreferrer">{c.linkLabel || 'Open external evidence'}</a></p>}
   {(c.evidence?.files?.length ? c.evidence.files : c.evidence?.fileUrl ? [{
          fileUrl: c.evidence.fileUrl,
          filename: 'Supporting evidence'
        }] : []).map((f, i) => <p key={i}><a href={f.fileUrl} target="_blank" rel="noreferrer">{f.filename || 'View document'}</a></p>)}
   {c.task && <p>Task: {c.task.status} — {c.task.recipientName}</p>}
   <ComplianceNextDue cell={c} rowId={rowId} dbName={dbName} token={token} readOnly={readOnly} onChanged={load} />
  </>}
  {c.inspectorNote && <p>{c.inspectorNote}</p>}<TrainingResults cell={c} />
 </>}<button onClick={load} style={{
      marginTop: 10
    }}>Refresh evidence</button></section>;
}
